
jQuery(document).ready(function () {
    if(window.location.href.indexOf('/account/reset') < 0) {
      
  		initCustomer();
       setTimeout(function() {
  		    cartPopupDiscounts();
        }, 3000);
  	}
      console.log('Discount Tags: ' + GetDiscountTags());
});
function getCustomerId() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch(e) { }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }    
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    return null;
  }

function initCustomer() {
  var customerId = getCustomerId();
  var proCodes = '65Yak65Pro60Pro50Pro40Pro30Pro30SPARC40SPARC50SPARCIPAConnectYakimaEmployee';
  var discount = readCookie("discount_code");
  var lsDiscount = localStorage.getItem('couponCode');
  var lsExpire = localStorage.getItem('couponExpire');
  var rootPath = window.location.href;
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  
  if(lsDiscount !== null && lsDiscount == discount && lsExpire !== null && new Date(lsExpire) < new Date()) {
    console.log('Coupon expired');
    discount = '';
    setCookie('discount_code', '', 1);
    localStorage.removeItem('couponCode');
    localStorage.removeItem('couponExpire');
    
  }
  if((partnerId == null || partnerId.length == 0) && ipCountry != 'ca')
  {
    if(rootPath.indexOf('/cart') >= 0) {
      if(discount != null && discount.length > 0 && proCodes.indexOf(discount) < 0) {
          jQuery('#cartDiscountCode').val(discount);
          jQuery('#cartApply').text('Remove Discount');

        }
      else {
        if(discount != null && discount.length > 0 && (proCodes.indexOf(discount) >= 0 || discount.indexOf('PSIA') >= 0 || discount.indexOf('NSP') >= 0)) {
          jQuery('.pro-discount').hide();
        }
      }
    }
    if(rootPath.indexOf('/pages/pro') >= 0) {
      
      if(discount != null && discount.length > 0) {
        if(proCodes.indexOf(discount) < 0) {
          jQuery('#proMessage').text('Your code has been applied. You can begin shopping Yakima.com.');
          jQuery('#proDiscountCode').val(discount);
          jQuery('.pro-section').addClass('disabled');
          jQuery('.pro-discount a.btn').text('Remove Discount');

        }
        else {
          jQuery('.pro-apply-button').first().find('a').first().text('RESUBMIT CREDENTIALS');
          jQuery('.pro-apply-title').first().find('h2').first().text('Reapply For Pro');
          jQuery('.pro-section').first().addClass('disabled');
          jQuery('.pro-discount').hide();
        }
        if(discount.indexOf('PSIA') >= 0 || discount.indexOf('NSP') >= 0) {
            jQuery('#discount-message').text('Pro Program participants are not eligible for additional discounts.');
            jQuery('.pro-section').addClass('disabled');
          jQuery('.pro-section').first().addClass('disabled');
          jQuery('.pro-discount').hide();

        }
      }
    }
    if(customerId == null) {
      if(discount != null && discount.length > 0 && (proCodes.indexOf(discount) >= 0)) {
     //   setCookie('discount_code', '', 1);
     //   localStorage.removeItem('couponCode');
 //     	window.location = '/discount/ ?redirect=/';
      }
     //   else if(rootPath.indexOf('account/') < 0 && rootPath.indexOf('retailer-fmc') < 0 && (discount == null || discount.length == 0) && rootPath.indexOf('yakima.com') >= 0 && rootPath.indexOf('explore.yakima.com') < 0) {
      //   setCookie('discount_code', 'BELIEVEITORNOT', 1);
      // localStorage.setItem('couponCode', 'BELIEVEITORNOT');
      //    console.log('/discount/BELIEVEITORNOT?redirect=' + window.location.pathname);
      //  	window.location = '/discount/BELIEVEITORNOT?redirect=' + window.location.pathname;
     // }
    }
    else {
      if(customerId.toString().length > 0 && customerId.toString().length < 20 && rootPath.indexOf('account/activate') < 0) {
		var url = 'https://api.yakima.com/api/shopify/GetCustomerTags/' + customerId;
        jQuery.get(url, function (data) {
          tags = data;
          var discount = "";
          if(tags.indexOf('65Yak') >= 0)
            discount = '65Yak';
          if(tags.indexOf('65Pro') >= 0)
            discount = '65Pro';
          if(tags.indexOf('60Pro') >= 0)
            discount = '60Pro';
          if(tags.indexOf('50Pro') >= 0)
            discount = '50Pro';  
          if(tags.indexOf('40Pro') >= 0)
            discount = '40Pro';
          if(tags.indexOf('30Pro') >= 0)
            discount = '30Pro';
          if(tags.indexOf('30SPARC') >= 0)
            discount = '30SPARC';
          if(tags.indexOf('40SPARC') >= 0)
            discount = '40SPARC';
          if(tags.indexOf('50SPARC') >= 0)
            discount = '50SPARC';
          if(tags.indexOf('IPAConnect') >= 0)
            discount = 'IPAConnect';
          if(tags.indexOf('YakimaEmployee') >= 0)
            discount = 'YakimaEmployee';

       

            var discountCookie = readCookie("discount_code");
            if((discountCookie == null || discountCookie == '' || discountCookie == 'BELIEVEITORNOT') && proCodes.indexOf(discount) >= 0) {
          //    setCookie('discount_code', discount, 1);
          //    localStorage.setItem('couponCode', discount);
            //  if(discount.length > 0)
      	//		window.location = '/discount/' + discount + '/?redirect=/';
            }


          if(rootPath.indexOf('/pages/pro') >= 0) {
            if(tags.indexOf('pro-accepted') >= 0)
              jQuery('#currentProStatus').text('You are part of the Yakima Pro program.');
            if(tags.indexOf('pro-pending') >= 0)
              jQuery('#currentProStatus').text('Your application is being processed.');
          }
        });
      }
      
    }
  }
}
function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
      

async function applyDiscount(prefix) {
  var rootPath = window.location.href;
  var couponCode = '';
  if(jQuery('#' + prefix + 'DiscountCode').length > 0)
  	couponCode = jQuery('#' + prefix + 'DiscountCode').val();
  console.log('Applying Discount ' + couponCode);
  if(jQuery('#' + prefix + 'Apply').first().text() == "Remove Discount") {
    
      localStorage.setItem('couponCode', '');
      var now = new Date();
    now.setDate(now.getDate() + 1);
      localStorage.setItem('couponExpire', new Date(now));
      setCookie('discount_code', '', 1);
      if(rootPath.indexOf('/pro') >= 0)
      	window.location = '/discount/ ?redirect=/pages/pro';
      else
      	window.location = '/discount/ ?redirect=/';
    
  }
  else {
    var proDiscounts = "30Pro,40Pro,50Pro,65Pro,60Pro,30PC,40PC,50PC,65PC,40PL,40SPARC,30SPARC,50SPARC,IPAConnect";
    var avantlinkCodes = "kayla20,justin20,996roadtrip20,bubba20,rachel20";

        if(couponCode.length > 0 && (couponCode.length < 8 && avantlinkCodes.indexOf(couponCode.toLowerCase()) < 0)) {
       jQuery('#' + prefix + 'Message').text('Incorrect Code - Please try again.');

    }

   // else {
    //  localStorage.setItem('couponCode', couponCode);
   //   var url = 'https://gost.yakima.com/api/shopify/ConfirmDiscount/' + couponCode;
    //    jQuery.get(url, function (data) {
          
      //		if(data == "OK") {
       //   		localStorage.setItem('couponCode', couponCode);
      //        setCookie('discount_code', couponCode, 1);
          //    if(rootPath.indexOf('pages/pro') >= 0)
           //     window.location = '/discount/' + couponCode + '?redirect=/pages/pro';
          //    else if(couponCode.length > 0)
         //       window.location = '/discount/' + couponCode + '?redirect=/';
       //    }
         //   else {
          //     jQuery('#' + prefix + 'Message').text('Incorrect Code - Please try again.');
          //  }
    	//});
     // }
  }
}
async function doesDiscountCodeExist(discountCode) {

 //   const result = await fetch(`/admin/discount_codes/lookup.json?code=${discountCode}`);

    return true; //result.status === 200;
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function GetDiscountAmount() {
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  
  if((partnerId == null || partnerId.length == 0) && ipCountry != 'ca')
  {
    var discount = readCookie("discount_code");
    console.log('discount code', discount);
    if(discount == null || discount.length == 0) 
      discount = localStorage.getItem('couponCode');
   
    if(discount != null && discount.length > 0) {
      var discountAmount = GetLegacyDiscount(discount.toLowerCase());
	  if(discountAmount == 0) {
		var prefix = discount.substr(3, 2);
        if(discount.length < 8)
          prefix = discount.substr(0, 2);
		  if(!isNaN(prefix)) {
			discountAmount = parseInt(prefix);
		  }
	  }
                 
      return discountAmount;
    }
    else {
      return 0;
    }
  }
  else
    return 0;
}
function GetDiscountTags() {
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  var tags = '';
  var discountAmount = 0;
  
  if((partnerId == null || partnerId.length == 0) && ipCountry != 'ca')
  {
    var discount = readCookie("discount_code");
   
    if(discount != null && discount.length > 0) {
      var discountAmount = GetLegacyDiscount(discount.toLowerCase());
	  if(discountAmount == 0) {
		var prefix = discount.substr(3, 2);
        if(discount.length < 8)
          prefix = discount.substr(0, 2);
		  if(!isNaN(prefix)) {
			discountAmount = parseInt(prefix);
		  }
	  }
    }
      
    if(discount == '30SPARC')
      tags = '30_Eligible';
    else if(discount == '40SPARC')
      tags = '40_Eligible';
    else if(discount == '50SPARC')
      tags = '50_Eligible';
    else if(discountAmount == 65)
      tags = '60_Eligible';
    else 
      tags = discountAmount + '_Eligible';
    
  }
  return tags;
}

function GetLegacyDiscount(code) {
	var percent = 0;
	percent += LookupLegacyDiscount(code, 'yak20-30d', 30);
	percent += LookupLegacyDiscount(code, 'yak20-30p', 30);
	percent += LookupLegacyDiscount(code, 'tko', 30);
	percent += LookupLegacyDiscount(code, '30pc', 30);
	
	percent += LookupLegacyDiscount(code, 'orvis19', 40);
	percent += LookupLegacyDiscount(code, 'icast19', 40);
	percent += LookupLegacyDiscount(code, 'yak20-40d', 40);
	percent += LookupLegacyDiscount(code, 'yak20-40p', 40);
	percent += LookupLegacyDiscount(code, 'nica20-p', 40);
	percent += LookupLegacyDiscount(code, 'nica20-d', 40);
	percent += LookupLegacyDiscount(code, 'odpl20', 40);
	percent += LookupLegacyDiscount(code, 'prom20', 40);
	percent += LookupLegacyDiscount(code, 'leo20', 40);
	percent += LookupLegacyDiscount(code, 'yg2040', 40);
	percent += LookupLegacyDiscount(code, '40pl', 40);
	
	percent += LookupLegacyDiscount(code, '50pc', 50);
	percent += LookupLegacyDiscount(code, 'yak20-50d', 50);
	percent += LookupLegacyDiscount(code, 'yak20-50p', 50);
	percent += LookupLegacyDiscount(code, 'yg2050', 50);
	
	percent += LookupLegacyDiscount(code, 'yg2060', 60);
	
	percent += LookupLegacyDiscount(code, 'muo', 65);
	percent += LookupLegacyDiscount(code, '65yak', 65);
	percent += LookupLegacyDiscount(code, '65pro', 65);
	percent += LookupLegacyDiscount(code, '60pro', 60);
	percent += LookupLegacyDiscount(code, 'seaotter30', 30);
	percent += LookupLegacyDiscount(code, 'ipaconnect', 40);
	percent += LookupLegacyDiscount(code, 'aprilfools2023', 20);
	percent += LookupLegacyDiscount(code, 'sp23reimegapro', 70);
	percent += LookupLegacyDiscount(code, 'laborday', 20);
	percent += LookupLegacyDiscount(code, 'yakimaemployee', 65);

  
	percent += LookupLegacyDiscount(code, 'kayla20', 20);
	percent += LookupLegacyDiscount(code, 'justin20', 20);
	percent += LookupLegacyDiscount(code, '996roadtrip20', 20);
	percent += LookupLegacyDiscount(code, 'bubba20', 20);
	percent += LookupLegacyDiscount(code, 'rachel20', 20);
	percent += LookupLegacyDiscount(code, 'believeitornot', 0);
	return percent;
}
function LookupLegacyDiscount(myCode, code, percent) {
	if(myCode.substr(0, code.length) == code)
		return percent;
	else
		return 0;
}

function InitProductPage() {
  console.log('initproductpage');
    var discountAmount = GetDiscountAmount();
  var productId = $('#product-id').text();
  var tags = $('#product-tags').text();
  var sku = $('.variant-sku').first().text();
  var productName = $('.product-single__title').first().text();
  var priceText = $('.product-single__meta #product-price').text();
  var discountedPrice = false;
  if(priceText.length == 0) {
      priceText = $('.price-item--sale').first().text().trim();
    discountedPrice = true;
  }
  var price = parseFloat(priceText.replace('Starting at ', '').replace('$', '').replace(',', ''));
  
  var discount = readCookie("discount_code");
  if(discount == null || discount.length == 0) 
      discount = localStorage.getItem('couponCode');
  
  if(discount != null && discount.length > 0) {
    var prefix = discount.substr(0, 2);
    if(ValidForDiscount(tags, discount, discountAmount)) {
      if(discountAmount > 0) {
      
        var price = parseFloat(priceText.replace('Starting at ', '').replace('$', '').replace(',', ''));
        var discountPrice = price * ((100 - discountAmount) / 100);
        var newText = '<del>$' + price.toFixed(2) + '</del> <span class="red">$' + discountPrice.toFixed(2) + '</span>';
        if(discountedPrice) {
            priceText = $('.price-item--regular').first().text().trim();
          
            var fullPrice = parseFloat(priceText.replace('Starting at ', '').replace('$', '').replace(',', ''));
            var percentOff = (1 - (discountPrice / fullPrice)) * 100;
            newText = '$' + discountPrice.toFixed(2) + ' <span style="font-size: 0.7em;font-weight:300;">save ' + percentOff.toFixed(0) + '%</span>';

        //	$('.price-item--sale').first().html(newText);
        }
        else {
       //   if(priceText.indexOf('Starting at') >= 0)
       //   	$('#product-price').html('Starting at ' + newText);
       //   else
    //      	$('#product-price').html(newText);
        }
      }
    }
    else {
      if(discountAmount > 0 && document.getElementById("product-price") != null) {
        var priceText = $('#product-price').text();
        var newText = priceText + ' <span class="red">(Not available for discount)</span>';
  //      document.getElementById("product-price").innerHTML = newText;
      }
    }
  }
    window.setTimeout(function() {
        var gridItems = [];
        var cnt = 0;
     
        $('ul.grid li').each(function() {
          
          var tagBox = $(this).find('.product-tags').first();
          var sku = $(this).find('.product-card__sku').first().text().replace('SKU: #', '');
          if(discountAmount > 0) {
            if(ValidForDiscount(tagBox.text(), discount, discountAmount)) {
              priceText = jQuery(this).find('dl.price .price-item--regular').first().html();
              if(priceText != null) {
                price = parseFloat(priceText.replace('$', '').replace(',', ''));
                discountPrice = price * ((100 - discountAmount) / 100);
                newText = '<del>' + priceText + '</del> <span class="red">$' + discountPrice.toFixed(2) + '</span>';
                $(this).find('dl.price .price-item--regular').first().html(newText);
              }
            }
            else {
             
              priceText = jQuery(this).find('dl.price .price-item--regular').first().html();
              var newText = priceText + ' <span class="red">(Not available for discount)</span>';
              $(this).find('dl.price .price-item--regular').first().html(newText);
            }
          }
          if(jQuery(this).closest('#shopify-section-product-recommendations').length) {
            var itemName = jQuery(this).find('.grid-view-item__title').first().text();
            var sku = jQuery(this).find('.product-card').first().attr('data-sku');
            var itemPrice = jQuery(this).find('.price-item--regular').first().text().replace('$', '').replace(',', '');
            jQuery(this).attr('data-cnt', cnt);
            if(itemName.length > 0) {
              var gridItem = {
                  item_id: sku,
                  item_name: itemName,
                  affiliation: "Yakima Store",
                  coupon: null,
                  currency: "USD",
                  discount: 0,
                  index: cnt,
                  item_brand: "Yakima",
                  item_category: null,
                  item_category2: null,
                  item_category3: null,
                  item_category4: null,
                  item_category5: null,
                  item_list_id: "shop-similar-products",
                  item_list_name: "Shop Similar Products",
                  item_variant: "Default",
                  price: parseFloat(itemPrice),
                  quantity: 1 
                };
              cnt++;
              gridItems.push(gridItem);
              console.log(gridItem);
    
              jQuery(this).click(function() {
                dataLayer.push({
                    ecommerce: null
                }); // Clear the previous ecommerce object.
                dataLayer.push({
                  event: "gtmEcommerceEvent",
                  eventName: "select_item",
                  eventCategory: "ecommerce",
                  eventAction: "product click",
                  eventLabel: itemName,
                  nonInteractionHit: false,
                  ecommerce: {
                      items: [{
                          item_id: sku,
                          item_name: itemName,
                          affiliation: "Yakima Store",
                          coupon: null, 
                          currency: "USD",
                          discount: 0,
                          index: jQuery(this).attr('data-cnt'), 
                          item_brand: "Yakima",
                          item_category: null, 
                          item_category2: null, 
                          item_category3: null, 
                          item_category4: null, 
                          item_category5: null, 
                          item_list_id: "shop-similar-products",
                          item_list_name: "Shop Similar Products",
                          item_variant: "Default", 
                          price: parseFloat(itemPrice), 
                          quantity: 1
                      }]
                  }
              });
          });
          
        }
      }
      });
      dataLayer.push({
            ecommerce: null
          }); // Clear the previous ecommerce object.
        dataLayer.push({
            event: "gtmEcommerceEvent",
            eventName: "view_item_list",
            eventCategory: "ecommerce",
            eventAction: "product impressions",
            eventLabel: null,
            nonInteractionHit: true,
            ecommerce: {
                  items: gridItems 
            }
        });
    }, 1000);

  dataLayer.push({
    ecommerce: null
  });
  
  dataLayer.push({
      event: "gtmEcommerceEvent",
      eventName: "view_item",
      eventCategory: "ecommerce",
      eventAction: "product detail view",
      eventLabel: productName,
      nonInteractionHit: true,
      ecommerce: {
          items: [{
              item_id: sku,
              item_name: productName,
              affiliation: "Yakima Store",
              coupon: null, 
              currency: "USD",
              discount: 0,
              item_brand: "Yakima",
              item_category: null, 
              item_category2: null, 
              item_category3: null,
              item_category4: null, 
              item_category5: null, 
              item_variant: "Default",
              price: price,
              quantity: 1
          }]
      }
  });
}
function ValidForDiscount(tags, discount, discountAmount) {
  var valid = false;
     if(tags.indexOf(discountAmount + '_Eligible') >= 0 && tags.indexOf('close out') < 0) {
      valid = true;
    }
  if(discountAmount == 65 && tags.indexOf('closeout') < 0 && tags.indexOf('60_Eligible') >= 0)  valid = true; 
  if(discount == 'Y2150D-W5K4M7' || discount == 'Y2150D-H34Z94' || discount == 'Y2150D-T3MSHK' || discount == 'Y2150D-T76TQJ' || discount == 'Y2150D-328S7J' || discount.toUpperCase() == 'SEAOTTER30' || discount.toUpperCase() == 'SALE2TRAIL')
    valid = true;
  
  return valid;
}
function InitCollectionPage() {
//  var discountAmount = GetDiscountAmount();
//  if(discountAmount > 0) {
//    $('li.grid__item').each(function() {
//      var priceBox = $(this).find('.price-item--regular').first();
//      var tagBox = $(this).find('.product-tags').first();
//      var mainBox = $(this).find('dl.product-price').first();
//      if(tagBox.text().indexOf(discountAmount + '_Eligible') >= 0 || discountAmount == 65) {
//        var priceText = priceBox.text();
//        var price = parseFloat(priceText.replace('$', ''));
//        var discountPrice = price * ((100 - discountAmount) / 100);
//        var newText = '<del>' + priceText + '</del> <span class="red">$' + discountPrice.toFixed(2) + '</span>';
//        priceBox.html(newText);
//        mainBox.clear().html(newText);
//      }
//    });

//  }
  
    // jQuery('ul.grid li.grid__item').each(function() {
    
   //       var tags = jQuery(this).find('.product-tags').first().text();
    //  console.log(tags);
     //     if(tags.toLowerCase().indexOf('bike') < 0)
      //    {
       //     jQuery(this).find('div.ss-sale-price').first().addClass('hidden').hide();
       //   }
       // });
}
function InitCartPage() {
  var discountAmount = GetDiscountAmount();
    var discount = readCookie("discount_code");
    if(discount == null || discount.length == 0) 
      discount = localStorage.getItem('couponCode');
  if(discountAmount > 0) {
    var subtotal = 0;
    $('td.cart__final-price .cart-item-price').each(function() {
      var priceBox = $(this).find('span').first();
      var tagBox = $(this).find('.product-tags').first();
      
      var priceText = priceBox.text();
      var price = parseFloat(priceText.replace('$', '').replace(',', ''));
      
  
      
  	  if(ValidForDiscount(tagBox.text(), discount, discountAmount)) {
        var discountPrice = price * ((100 - discountAmount) / 100);
        var newText = '<del>' + priceText + '</del> <span class="red">$' + discountPrice.toFixed(2) + '</span>';
        priceBox.html(newText);
        subtotal += discountPrice;
      }
      else
        subtotal += price;
    });
    
    var priceText = $('#shopify-section-cart-template #cart-subtotal').text();
    var price = parseFloat(priceText.replace('$', ''));
    var newText = '<del>' + priceText + '</del> <span class="red">$' + subtotal.toFixed(2) + '</span>';

    $('#shopify-section-cart-template #cart-subtotal').html(newText);
    
  }
}


function cartPopupDiscounts() {
  var discountAmount = GetDiscountAmount();
  var fitId = localStorage.getItem('fitId');
  var freeShipThreshold = 499;
  if(fitId == null) fitId = 0;

  console.log('discount amount', discountAmount);
  var proDiscounts = "30Pro,40Pro,50Pro,65Pro,60Pro,30PC,40PC,50PC,65PC,40PL,30SPARC,40SPARC,50SPARC,IPAConnect";
  var freightSkus = "8007192,8007335,8007336,8007368,8007369,8007370,8007371,8007398,8007512,8007518,8007519,8007534,8007535,8008107,8008129,8008130,8008133";
    var discount = '';
  	var cookie = readCookie("discount_code");
    if(cookie == null)
      cookie = localStorage.getItem('couponCode')
    if(cookie != null)
      discount = cookie;
    var label = 'Apply Discount';
  if(discountAmount > 0) {
    var subTotal = 0;
    jQuery('.cart-popup__items .cart-popup-item').each(function () {
        var cartItem = this;

      var priceText = jQuery(cartItem).find('.cart-item-regular-price').first().text();
      var sku = jQuery(this).find('ul.product-details li.product-details__item').first().text().replace('SKU: #', '');
      var tags = jQuery(this).find('.product-tags').first().text();
        var price = parseFloat(priceText.replace('$', '').replace(',', ''));
      if(tags.indexOf('Close Out') < 0) {
      if(ValidForDiscount(tags, discount, discountAmount)) {
        price = price * ((100 - discountAmount) / 100);
        console.log('changing price to', price);
        if(parseFloat(priceText.replace('$', '').replace(',', '')) != price.toFixed(2)) {
        var newText = '<del>' + priceText + '</del> <span class="red">$' + price.toFixed(2) + '</span>';
    //    jQuery(cartItem).find('.cart-item-regular-price').first().html(newText);
        }
      }
      }
      subTotal += price;
        

    });
    
      var totalText = jQuery('.cart-popup-subtotal__price').first().text();
    
        if(totalText != '$' + subTotal.toFixed(2)) {
      var newTotal = '<del>' + totalText + '</del> <span class="red">$' + subTotal.toFixed(2) + '</span>';
   //   jQuery('.cart-popup-subtotal__price').first().html(newTotal);
        }
    
    
  }
  var totalPrice = 0;
  var cnt = 0;
  jQuery('.cart-popup__items .cart-popup-item').each(function () {
        var cartItem = this;
      var sku = jQuery(this).find('ul.product-details li.product-details__item').first().text().replace('SKU: #', '');
      if(freightSkus.indexOf(sku) >= 0) freeShipThreshold = 999;
      var tags = jQuery(this).find('.product-tags').first().text();
      var priceText = jQuery(cartItem).find('.cart-item-regular-price').first().text();
      
      if(jQuery(cartItem).find('.limoniapps-discountninja-shortcode-discounted_price').length > 0) 
        priceText = jQuery(cartItem).find('.limoniapps-discountninja-shortcode-discounted_price').first().text();
      console.log('pricetext', priceText);

      var price = parseInt(priceText.replace('$', '').replace(',', ''));
        totalPrice += price;
    cnt++;
        var url = 'https://api.yakima.com/api/fitnote/GetFitNotes/' + fitId + '/' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery.each(data, function (i, e) {
                if(e.skuFilter.indexOf('+') <= 0 && e.note != null) //Ignore the combined SKU filters, like the Roundbar warnings
                    jQuery(cartItem).find('ul.product-details li.product-details__item').append('<p style="color: #811a1e; clear: both; font-weight: bold;">* ' + e.note + '</p>');
            });
        });
    if(tags.toLowerCase().indexOf('close out') >= 0 && sku != '8005045' && sku != '8005046' && sku != '8005047' && sku != '8005048' && sku != '8005063')
        jQuery(cartItem).find('ul.product-details li.product-details__item').append('<p style="color: #811a1e; clear: both; font-weight: bold;">* Deep Discount items are final sale and can not be returned.</p>');

    });
  

    //    jQuery('#popupFreeShipping').remove();
  	//	jQuery("<p class='red' id='popupFreeShipping' style='margin: 10px; font-size: 14px;'>Please be aware that current weather conditions may cause shipping delays.</p>").insertBefore('.cart-popup__checkout-items').first();

    console.log('discount', discount);
  if(discountAmount > 0 && proDiscounts.indexOf(discount) >= 0) {
    //Don't show discount box for Pro Users
  }
  else {
    if(discountAmount > 0) 
      label = 'Remove Discount';
    else {
      if(totalPrice < freeShipThreshold && cnt > 0) {
        jQuery('#popupFreeShipping').remove();
  		jQuery("<p class='red' id='popupFreeShipping'>Only $" + (freeShipThreshold - totalPrice).toString() + " from Free Shipping!</p>").insertAfter('.cart-popup-shipping').first();
      }
    }
  	var html = '<p id="popupDiscount" class="pro-discount"> <input type="text" id="popupDiscountCode" value="' + discount + '"> <a id="popupApply" class="btn" href="#" onclick="applyDiscount(\'popup\')">' + label + '</a><span id="popupMessage" class="discountMessage"></span></p>';
   // if(jQuery('#popupDiscount').length == 0)
  //		jQuery(html).insertAfter('.cart-popup__checkout-items button');
  }
  

}
function submitProApplication() {
  var femail = $('#email').val();
  var femployer = $('#employer').val();
  var finterests = $('#interests  option:selected').text();
  var fbiography = $('#outdoorBiography').val();
  var findustry = $('#outdoorIndustry option:selected').text();
  
  console.log(finterests);
  console.log(findustry);
  
  var json = ""; //JSON.stringify({email: email});
  //, employer: employer, interests: interests, biography: biography, industry: industry
  
  console.log(json);
  
  $.ajax({
    url: "http://api.yakima.com/api/shopify/submitproapplication/" + femail + "/" + femployer + "/" + finterests + "/" + fbiography + "/" + findustry,
    type: 'GET',
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: json,
    success: function (data) {
        alert('Success!');
    },
    error: function (jqXHR, textStatus, errorThrown) {
        alert(errorThrown);
    }
  });
}
function encodeJSON(myJSON) {
  var myJSONString = JSON.stringify(myJSON);
  var myEscapedJSONString = myJSONString.replace(/\\n/g, "\\n")
                                      .replace(/\\'/g, "\\'")
                                      .replace(/\\"/g, '\\"')
                                      .replace(/\\&/g, "\\&")
                                      .replace(/\\r/g, "\\r")
                                      .replace(/\\t/g, "\\t")
                                      .replace(/\\b/g, "\\b")
                                      .replace(/\\f/g, "\\f");
  return myEscapedJSONString;
}
